
import React from 'react';
import { Button } from "@/components/ui/button";
import { logger } from "@/lib/logger";

interface CalendlyEmbedProps {
  buttonText: string;
  buttonClassName?: string;
  calendlyURL?: string;
}

const CalendlyEmbed: React.FC<CalendlyEmbedProps> = ({
  buttonText,
  buttonClassName = "",
  calendlyURL = "https://calendly.com/me-freelancewithandy/30min"
}) => {
  const openCalendlyInNewTab = () => {
    logger.log('Opening Calendly in new tab:', calendlyURL);
    window.open(calendlyURL, "_blank", "noopener,noreferrer");
  };

  return (
    <Button 
      className={buttonClassName} 
      onClick={openCalendlyInNewTab}
    >
      {buttonText}
    </Button>
  );
};

export default CalendlyEmbed;
